// extracted by mini-css-extract-plugin
module.exports = {"box":"rating_box-module_box_a1dbd","hidden":"rating_box-module_hidden_1c5af"};